import { format } from 'date-fns';

import { utcStartOfDay } from '@paradigm/utils/src/date';

import { DraftOptionLeg } from '#/unified-rfqs/ui/rfq-builder/types';
import { UnifiedInstruments } from '#/unified-rfqs/ui/instruments/types';
import { areExpirationsEqual } from './expiration-utils';

export function optionExpirationView(
  selectedExpiration: DraftOptionLeg['expiration'],
  instruments: UnifiedInstruments['optionInstruments'],
) {
  const expirations = instruments.map((ins) => ins.expiration);
  const uniqueExpirations = [...new Set(expirations)];

  const options = uniqueExpirations.map((expiration) => ({
    value: expiration,
    label: formatExpiration(expiration),
  }));

  const selectedOption =
    options.find((option) =>
      areExpirationsEqual(option.value, selectedExpiration),
    ) ?? null;

  const isValid = selectedOption !== null;

  const isDisabled = options.length === 0;

  return { options, selectedOption, isValid, isDisabled };
}

function formatExpiration(expiration: number) {
  const date = utcStartOfDay(new Date(expiration));
  return format(date, 'dd MMM yy');
}
